import axiosClient from "./axiosClient";

function toQueryString(params = {}) {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      searchParams.append(key, value);
    }
  });
  const query = searchParams.toString();
  return query ? `?${query}` : "";
}

export async function getCategories(params) {
  const response = await axiosClient.get(`/Categories${toQueryString(params)}`);
  return response.data;
}

export async function getCategoryAttributes(id) {
  const response = await axiosClient.get(`/Categories/${id}/attributes`);
  return response.data;
}

export async function setCategoryAttributes(id, payload) {
  const response = await axiosClient.put(`/Categories/${id}/attributes`, payload);
  return response.data;
}
